import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import {
  GEO_API_PROXY_ENDPOINT,
  ADMINISTRATIVE_DIVISION_API_ENDPOINT,
  createGeoFetcher,
} from '@e-socna/gis';
import { isDefined } from '@e-socna/utils';

import { environment } from '../../../../environment';

import type { AdministrativeDivision } from '../../types/geo/administrative-division.type';

interface Params {
  readonly inseeCode: string;
  readonly enabled?: boolean;
  readonly fields?: string;
}

const geoFetch = createGeoFetcher('adminDivision');

export const useAdministrativeDivisionQuery = <
  R extends object = AdministrativeDivision,
>(
  pParams: Params,
) => {
  const { fetcher } = useMemo(() => {
    const uri = pParams.inseeCode;

    const params = {
      fields: pParams.fields ?? 'code,nom,departement,region',
    };

    const queryString = new URLSearchParams(params).toString();

    const url = `${environment.backendUrl}${GEO_API_PROXY_ENDPOINT}/${ADMINISTRATIVE_DIVISION_API_ENDPOINT}/${uri}?${queryString}`;

    return {
      fetcher: () => geoFetch<R>(url),
    };
  }, [pParams.fields, pParams.inseeCode]);

  return useQuery({
    queryKey: [
      'useAdministrativeDivisionQuery',
      pParams.inseeCode,
      pParams.fields,
    ],
    queryFn: fetcher,
    enabled: isDefined(pParams.enabled) ? pParams.enabled : true,
  });
};
